import React, { forwardRef } from "react";
import { ReactComponent as AddIcon } from "assets/icons/add.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { ReactComponent as EditIcon } from "assets/icons/edit.svg";
import { ReactComponent as ExportIcon } from "assets/icons/export.svg";
import { ReactComponent as ReadIcon } from "assets/icons/eye.svg";
import { ReactComponent as GroupIcon } from "assets/icons/group.svg";
import { ReactComponent as MoreIcon } from "assets/icons/more.svg";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../LoadingSpinner";
import {
  IconButton,
  NavigateButton,
  PrimaryButton,
  SecondaryButton,
  SquareButton,
  TextButton,
} from "./CustomButton.styles";

const CustomButton = forwardRef(
  (
    {
      onClick = () => {},
      children,
      style,
      type = "button",
      variant = "primary",
      disabled,
      to,
      $text,
      $iconSize = {},
      $loading = false,
      color,
      $bgColor,
      $disableAnimation = false,
      isHidden = false,
    },
    ref,
  ) => {
    const { t } = useTranslation();

    const props = {
      onClick,
      children,
      style,
      type,
      variant,
      disabled,
      to,
      $iconSize,
      $loading,
      $text,
      color,
      $bgColor,
      $disableAnimation,
      ref,
    };

    if (isHidden) {
      return <></>;
    }

    switch (variant) {
      case "more": {
        return (
          <IconButton {...props}>
            <MoreIcon />
          </IconButton>
        );
      }
      case "close": {
        return (
          <IconButton {...props}>
            <CloseIcon />
          </IconButton>
        );
      }
      case "export": {
        return (
          <PrimaryButton {...props}>
            {t("Button.downloadCSV")} <ExportIcon />
          </PrimaryButton>
        );
      }
      case "read": {
        return (
          <IconButton {...props}>
            <ReadIcon />
          </IconButton>
        );
      }
      case "add":
        return (
          <SquareButton {...props}>
            <AddIcon />
          </SquareButton>
        );
      case "refresh":
        return (
          <SquareButton {...props}>
            <GroupIcon />
          </SquareButton>
        );
      case "edit":
        return (
          <SquareButton {...props}>
            <EditIcon />
          </SquareButton>
        );
      case "icon":
        return <IconButton {...props}>{children}</IconButton>;
      case "text":
        return <TextButton {...props}>{children}</TextButton>;
      case "navigate":
        return (
          <NavigateButton target="_blank" to={to} {...props}>
            {children}
          </NavigateButton>
        );
      case "secondary":
        return <SecondaryButton {...props}>{children}</SecondaryButton>;
      default: {
        return (
          <PrimaryButton {...props}>
            {children}
            {!!$loading && (
              <LoadingSpinner
                style={{ marginLeft: 10 }}
                width="30"
                height="30"
              />
            )}
          </PrimaryButton>
        );
      }
    }
  },
);

export default CustomButton;
